<template>
	<div>
		<v-toolbar color="primary" dense dark>
			<v-btn icon @click="$emit('onClose')">
				<v-icon>mdi-close</v-icon>
			</v-btn>

			<v-toolbar-title>{{ $t("title.notifications") }}</v-toolbar-title>

			<v-spacer></v-spacer>

			<v-btn icon @click="getItems()" :loading="$wait.is('loading')">
				<v-icon>mdi-refresh</v-icon>
			</v-btn>
		</v-toolbar>

		<v-list three-line>
			<template v-for="(item, index) in items">
				<Link
					as="v-list-item"
					link
					:href="item.route"
					:key="index"
					:class="{ 'blue-grey lighten-5': !item.read_at }"
				>
					<v-list-item-avatar>
						<v-avatar color="accent">
							<v-icon light>{{ item.icon }}</v-icon>
						</v-avatar>
					</v-list-item-avatar>
					<v-list-item-content>
						<v-list-item-title
							class="font-weight-bold primary--text"
						>
							<v-row no-gutters fluid style="width: 100%">
								<v-col cols="auto">
									<span v-html="item.title"></span>
								</v-col>
								<v-col align-self="end" cols="auto">
									<v-badge
										dot
										color="red"
										:value="!item.read_at"
										class="pl-15 ml-15"
									></v-badge>
								</v-col>
							</v-row>
						</v-list-item-title>
						<v-list-item-subtitle
							class="line-clamp-3"
							v-html="item.subtitle"
						></v-list-item-subtitle>
						<v-list-item-subtitle>
							{{ item.created_at ? item.created_at : "recently" }}
						</v-list-item-subtitle>
					</v-list-item-content>
				</Link>
				<v-divider :key="'divider_' + index"></v-divider>
			</template>
		</v-list>
	</div>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue";
export default {
	components: {
		Link,
	},
	props: ["route"],
	data() {
		return {
			items: [],
		};
	},
	methods: {
		async getItems() {
			try {
				this.$wait.start("loading");
				const { data, status } = await axios.get(
					this.route
						? this.route
						: this.$route("central.notifications.index")
				);

				if (status == 200) {
					this.items = data.data.data;
				}
			} finally {
				this.$wait.end("loading");
				this.$page.props.auth.unreadNotificationsCount = 0;
			}
		},
	},
};
</script>

<style scoped>
.line-clamp-3 {
	-webkit-line-clamp: 3 !important;
}
</style>